// @flow
import AKDammCup from './AKDammCup'
import bockDammMug from './bockDammMug'
import complotGlass from './complotGlass'
import dammLemonMug from './dammLemonMug'
import estrellaDammCup from './estrellaDammCup'
import estrellaDammGlass from './estrellaDammGlass'
import estrellaDammMug from './estrellaDammMug'
import ineditGlass from './ineditGlass'
import malqueridaCup from './malqueridaCup'
import vollDammCup from './vollDammCup'

const type = 'glassware'

export default [
  {
    ...estrellaDammCup,
    type
  },
  {
    ...complotGlass,
    type
  },
  {
    ...malqueridaCup,
    type
  },
  {
    ...AKDammCup,
    type
  },
  {
    ...estrellaDammGlass,
    type
  },
  {
    ...ineditGlass,
    type
  },
  {
    ...vollDammCup,
    type
  },
  {
    ...estrellaDammMug,
    type
  },
  {
    ...bockDammMug,
    type
  },
  {
    ...dammLemonMug,
    type
  }
]
